// const ENV = "dev";
// const ENV = "test";
// const ENV = "grey";
const ENV = "prod";

let baseUrl = {
    back: {
        dev: "http://192.168.2.143:8105/siqi-back",
        test: "http://192.168.2.9:8105/siqi-back",
        grey: "http://192.168.2.6:8105/siqi-back",
        prod: "https://siqiback.siqiit.com/siqi-back",
    },
    api:{
        dev: "http://192.168.2.143:8102/siqi-im",
        test: "http://192.168.2.9:8102/siqi-im",
        grey: 'https://imgrey.siqiit.com/siqi-im',
        prod: "https://siqiim.siqiit.com/siqi-im",
    }
};

const b = (c = "website", e = "dev") => {
    if (ENV !== "dev") {
        return baseUrl[c][ENV];
    } else {
        return baseUrl[c][e];
    }
};

export default {
    back: b('back'),
    code:{
        getSmsCode:b("api")+"/api/smsCode/getSmsCode",//获取验证码
        SmsCode:b("api")+"/api/smsCode/validateMobile",//获取验证码
    },
    form:{
        save: b("back") + "/api/form/save", //用户留言
    },
    news:{
        list: b("back") + "/api/news/list", //新闻列表
        queryDetail: b("back") + "/api/news/queryDetail", //新闻详情
    },
    document:{
        list: b("back") + "/api/document/list", //产品文档列表
        countDownload: b("back") + "/api/document/countDownload", //统计资料下载
        downloadFile: b("back") + "/api/document/downloadFile", //下载文件
    }
};



// WEBPACK FOOTER //
// ./src/api-url.js